module.exports = __webpack_public_path__ + "static/img/shareTelegram.939a1fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/shareTelegram.svg
// module id = FpPe
// module chunks = 0